import { FlatTreeControl } from '@angular/cdk/tree';
import { AfterViewInit, Component, Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import { CompanyService } from 'src/services/CompanyService';
import { DataService } from '../../../services/data.service';
import { ModuleService } from '../../../services/module.service';
import { RouterService } from '../../../services/router.service';
import { SystemInternalService } from '../../../services/systemInternal.service';
import { ISaveCompModu, ISaveModu } from '../../Interfaces/icompmodu';
import { Get_configV2, IconfigResponseV2 } from '../../Interfaces/iconfig';
import { moduleStatus } from '../../Interfaces/imodules';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';

interface Status {
  name: string;
  code: moduleStatus;
}

interface CfgNode {
  description: string;
  id: number;
  code: string;
  parentId: number;
  status:moduleStatus;
  startDate: Date;
  endDate: Date;
  instructions: string;
  children?: CfgNode[];
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  code: string;
  description: string;
  level: number;
  id: number;
  status:moduleStatus;
  startDate: Date;
  endDate: Date;
  instructions: string;
}


@Injectable()
export class FileDatabase {
}

@Component({
  selector: 'app-mymodules',
  templateUrl: './mymodules.component.html'
})

export class MyModulesComponent {
  FormModule: FormGroup;
  matcher = new ErrorStateMatcher1();
  private _transformer = (node: CfgNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      description: node.description,
      id: node.id,
      code: node.code,
      parentId: node.parentId,
      status: node.status,
      startDate: node.startDate,
      endDate: node.endDate,
      instructions: node.instructions,
      level: level

    };
  };


  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );


  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  constructor(
    private formBuilder: FormBuilder,
    private companyservice: CompanyService,
    private dataService: DataService,
    private systemInternal: SystemInternalService,
    private moduleService: ModuleService,
    private router: Router,
    private routerService: RouterService,
    private _snackBar: MatSnackBar) {
    this.FormModule = formBuilder.group({
      status: ['Inactivo',Validators.required],
      startDate: ['2000-01-01', Validators.required],
      endDate: ['2000-01-01', Validators.required],
      validator:['x',Validators.required]
    });
    this.initialize();
  }
  mensaje: string;
  Modules: CfgNode[] = [];
  companyname: string;
  r_status: string="";
  r_text: string;
  r_id: number;
  r_title: string = "";
  r_instructions: string = "Seleccione el módulo para su manejo";
  listStatus: Status[] = [{ code: 1, name: 'Activo' }, { code: 2, name: 'Inactivo' }, { code:4, name: 'Suspendido' }/*, { code:3, name: 'No aplica' }*/];

  initialize() {
    this.mensaje = "";
    this.companyname = this.companyservice.companyName;
    //consultar los permisos
    this.Modules = [];
    const gf: Get_configV2 = {
      companyId: this.companyservice.companyID,
      level: 1,
      id: 0,
      updateid: 0
    };
    this.moduleService.GetModulesAvailablesV2(this.companyservice.companyID).subscribe(results => {
      if (results.body.isValid) {
        for (const entry of results.body.resultData) {
          this.Modules.push(entry);
        }
        this.dataSource.data = this.Modules; // results.body.resultData; //   this.accounts; // TREE_DATA; //JSON.parse(td);//
      }
      else {
        alert(results.body.error.description); this.mensaje = results.body.error.description;
      }
    },
      (e) => {
        this.mensaje = e.error;
        console.log(e);
      });
  }



  GetDataTable(entry: IconfigResponseV2) {
  }


  b_back() {
    this.router.navigate([this.routerService.routerParent01]);
  }

  Save() {
    try {
      this.FormModule.controls['validator'].setValue('');
      const oModule:ISaveModu[] = [];

      for (const entry of this.dataSource._flattenedData.value) {
        if (entry.status != 3) {
          oModule.push({ id: entry.id, startDate: entry.startDate,endDate:entry.endDate, status: entry.status, code: entry.code });
        }
      }
      const oSaveModule: ISaveCompModu={
        companyId: this.companyservice.companyID, modules:oModule
      };
      this.moduleService.SaveCompanyModulesV1(oSaveModule).subscribe(results => {
        if (results.body.isValid) {
          this.openSB(results.body.resultData.description);
          this.b_back();
        }
        else { alert(results.body.error.description); }
      },
        (e) => {
          alert(e.error);
        }
      );
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  onClick(node) {
    try {
      this.r_id = node.id;
      this.r_status = node.status;
      this.r_title = node.description.trim();
      this.r_instructions = (node.instructions != null && node.instructions != "" ? node.instructions : "Opciones de " + node.description.trim() );
      this.FormModule.controls['status'].setValue(node.status);
      const [datecmp, timecmp] = node.startDate.split('T');
      const [enddatecmp, endtimecmp] = node.endDate.split('T');
      this.FormModule.controls['startDate'].setValue(datecmp);
      this.FormModule.controls['endDate'].setValue(enddatecmp);
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  onChange(getId, xnode) {
    try {
      if (this.FormModule.controls['startDate'].value > this.FormModule.controls['endDate'].value) {
        this.FormModule.controls['validator'].setValue('');
        this.openSB("Error en las fechas");
      }
      else {
        this.FormModule.controls['validator'].setValue('x');

      }
      var index: number = this.dataSource._flattenedData.value.indexOf(this.dataSource._flattenedData.value.find(x => x.id == getId));
      if (index >= 0) {
        this.dataSource._flattenedData.value[index].startDate = this.FormModule.controls['startDate'].value;
        this.dataSource._flattenedData.value[index].endDate = this.FormModule.controls['endDate'].value;
        this.dataSource._flattenedData.value[index].status = this.FormModule.controls['status'].value;
      }
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  searchNode(id) {
    var node = this.dataSource.data.find(x => x.id == id);
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.FormModule.get(nombreControl);
    return control.hasError(validacion);
  }
}
